var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction-body display-minimum free-response free-response-display-minimum"},[_c('div',{staticClass:"px-1rem pb-30 pp-interaction-body"},_vm._l((_vm.lineArray),function(line){return _c('div',{key:line,staticClass:"answer-line"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }